import { api } from "../plugins/api"
import { mapMutations } from "vuex"

export default {
  data() {
    return {}
  },
  methods: {
    ...mapMutations("ParamFormulaireDeprecated", { setRessources: "SET_RESSOURCES", addRessources: "ADD_RESSOURCES" }),
    async loadParams(id, merge = false) {
      const paramsFormulaireBrut = await api.get(`params-formulaires-deprecated/${id}`)
      const paramsFormulaire = JSON.parse(paramsFormulaireBrut.data)
      if (paramsFormulaire.paramRessources != null && paramsFormulaire.paramRessources.length > 0) {
        if (merge) {
          this.addRessources(paramsFormulaire.paramRessources)
        } else {
          this.setRessources(paramsFormulaire.paramRessources)
        }
      }
    },
  },
}
